import { motion } from "framer-motion";
import { PROCESS_STEPS } from "../data/content";
import { SectionHeading } from "./primitives";

export default function ProcessTimeline() {
  return (
    <section data-testid="process-timeline" className="mx-auto max-w-5xl px-5 py-24 lg:px-8 lg:py-32">
      <SectionHeading
        align="center"
        eyebrow="Our Process"
        title="A clear path from idea to launch"
        sub="No mystery, no runaround. Here's exactly how we work together."
        className="mb-16"
      />

      <div className="relative">
        <div className="absolute left-[27px] top-2 bottom-2 w-px bg-gradient-to-b from-brand via-brand-gold/40 to-transparent md:left-1/2" />

        <div className="space-y-8">
          {PROCESS_STEPS.map((step, i) => {
            const left = i % 2 === 0;
            return (
              <motion.div
                key={step.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: 0.05, ease: [0.22, 1, 0.36, 1] }}
                data-testid={`process-step-${i}`}
                className={[
                  "relative flex items-start gap-5 md:w-1/2",
                  left ? "md:pr-12" : "md:ml-auto md:flex-row-reverse md:pl-12 md:text-right",
                ].join(" ")}
              >
                <span className="relative z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl border border-white/10 bg-ink-soft">
                  <step.icon className="h-6 w-6 text-brand" strokeWidth={2} />
                  <span className="absolute -right-1 -top-1 flex h-6 w-6 items-center justify-center rounded-full bg-brand-gradient text-[11px] font-bold text-white">
                    {i + 1}
                  </span>
                </span>
                <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-6">
                  <h3 className="font-heading text-lg font-semibold text-white">{step.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{step.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
